import { render, staticRenderFns } from "./CheckupDisclaimer.vue?vue&type=template&id=a6dab6ac&scoped=true&"
import script from "./CheckupDisclaimer.vue?vue&type=script&lang=js&"
export * from "./CheckupDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dab6ac",
  null
  
)

export default component.exports